import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface StablecoinCurrent {
  usdt: number;
  usdc: number;
  dai: number;
  usde: number;
  total: number;
  usdtDominance: number;
  usdcDominance: number;
  daiDominance: number;
  usdeDominance: number;
  usdtFormatted: string;
  usdcFormatted: string;
  totalFormatted: string;
}

export interface StablecoinHistoryPoint {
  date: number;
  total: number;
  usdt: number;
  usdc: number;
  others: number;
  totalFormatted: string;
  usdtFormatted: string;
  usdcFormatted: string;
}

export interface StablecoinDominancePoint {
  date: number;
  usdt: number;
  usdc: number;
  others: number;
}

export interface StablecoinItem {
  id: string;
  name: string;
  symbol: string;
  supply: number;
  supplyFormatted: string;
  change7d: number;
  dominance: number;
  color: string;
}

export interface StablecoinsData {
  current: StablecoinCurrent;
  history: StablecoinHistoryPoint[];
  dominanceHistory: StablecoinDominancePoint[];
  stablecoins: StablecoinItem[];
  updatedAt: string;
}

export const useStablecoinsData = () => {
  return useQuery<StablecoinsData>({
    queryKey: ['stablecoins-charts'],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('stablecoins-charts', {
        body: {}
      });
      if (error) throw error;
      return data as StablecoinsData;
    },
    refetchInterval: 5 * 60 * 1000, // 5 min
    staleTime: 4 * 60 * 1000, // 4 min
  });
};
